<script>
    import {getObjects} from '../lib/data.js';
    import Loader from '../Utilities/Loader.svelte';

    let transforms = getObjects("transform", {fields: ['id', 'name']});
</script>

{#await transforms}
    <Loader />
{:then t}
    <table class="table is-fullwidth">
        <thead>
            <tr>
                <th>Transforms</th>
                <th style="width: 250px">Actions</th>
            </tr>
        </thead>
        <tbody>
            {#each t as transform}
            <tr>
                <td>{transform.name}</td>
                <td>
                    <a href="#/transforms/edit/{transform.id}" class="button">Edit</a>
                </td>
            </tr>
            {/each}
        </tbody>
    </table>
    <a href="#/transforms/edit/" class="button is-primary is-pulled-right">New Transform</a>
{/await}